import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import style from './PartnerNews.module.css';
import {getPartnerNews} from "./service";

const PartnerNews = () => {
    const [partnerNews, setPartnerNews] = useState({content: ''});
    const { content } = partnerNews;

    useEffect(() => {
        (async () => {
            const { data } = await getPartnerNews();
            setPartnerNews(data)
        })();
    }, []);

    return (
        <div className={style.wrapper}>
            <Typography.Paragraph style={{padding: 24}}>
                <div dangerouslySetInnerHTML={{__html: content}}/>
            </Typography.Paragraph>
        </div>
    );
};

export default PartnerNews;
